// WhatsApp redirect helper — uses REACT_APP_WHATSAPP_SUCCESS from env
const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_SUCCESS;
const COUNTRY_CODE = '91';

export const buildWhatsAppUrl = (message) => {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${COUNTRY_CODE}${WHATSAPP_NUMBER}?text=${encoded}`;
};

export const openWhatsApp = (message) => {
  window.open(buildWhatsAppUrl(message), '_blank', 'noopener,noreferrer');
};
